import { usePage } from "@inertiajs/react";
import type { ErrorState } from "../models/enums/errorState";
import { Role } from "../models/enums/role";
import type { User } from "../models/user";
import type { YearContext } from "../models/yearContext";

type SharedPageProps = {
  user?: User;
  version: string;
  year_contexts?: YearContext[];
  year_starts: number;
  year_ends: number;
  flash?: Message;
  disable_navbar?: boolean;
};

export type Message = {
  title: string;
  text?: string;
  state?: ErrorState;
  auto_close?: number;
};

export function useProps(): SharedPageProps {
  const { props } = usePage<SharedPageProps>();

  return props;
}

export function useUser() {
  const { user } = useProps();

  return user;
}

export function useRole() {
  const { user } = useProps();

  return user?.role ?? null;
}

export function useDisableNavbar() {
  const { disable_navbar } = useProps();

  return disable_navbar ?? false;
}

export function useVersion() {
  const { version } = useProps();

  return version;
}

export function useMessage(): Message | undefined {
  const { flash } = useProps();
  return flash;
}

export function useYearContexts() {
  const { year_contexts } = useProps();
  return year_contexts ?? undefined;
}

export function useAdmin() {
  const role = useRole();
  return role === Role.ADMIN;
}
